import NotificationBell from './NotificationBell';
import React, { useState , useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from './Breadcrumb';
import { BiMenu } from 'react-icons/bi';

function Navbar({toggleSidebar , isSidebarOpen}) {  
  const [open, setOpen] = useState(false);
  useEffect(()=> {
          setOpen(!open)
  },[isSidebarOpen]);
  return (
    <>
      <nav className="bg-transparent relative z-10 border-b  border-opacity-25 lg:border-none lg:bg-transparent" aria-label="Dashboard">
        <div className="w-full px-4 sm:px-6 lg:px-8 flex justify-between items-center">
          <div className="relative flex h-16 items-center justify-between">
            <div className="flex items-center space-x-4 w-full">
              <Breadcrumb />
            </div>
          </div>
            <button type="button"
              className="flex md:hidden rounded-full text-sm text-gray focus:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-200"
              aria-expanded={open}
              onClick={toggleSidebar}
            >
              <BiMenu size={25}/>
            </button>
          
          
        </div>
      </nav>
    </>
  );
}

export default Navbar;



